import { render, staticRenderFns } from "./HighTech.vue?vue&type=template&id=b3624a32&"
import script from "./HighTech.vue?vue&type=script&lang=js&"
export * from "./HighTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports